import classNames from 'classnames';
import { default as NextLink } from 'next/link';
import type { ReactElement } from 'react';
import React from 'react';
import type { NavigationLink } from 'types/navigation-link';
import type PropsWithClassname from 'types/props-with-classname';
import { validateString } from 'utils/validate-string';

import styles from './navigation-item.module.scss';

interface Props extends PropsWithClassname {
  readonly link: NavigationLink;
  readonly onClick?: () => void;
}

const navigationMenuListItemClass = validateString(
  styles.navigationMenuListItem,
);
const navigationMenuLinkClass = validateString(styles.navigationMenuLink);

function NavigationItem({
  link,
  className: classProp,
  onClick,
}: Props): ReactElement {
  const extraProps: { onClick?: () => void } = {};
  if (typeof onClick !== 'undefined') {
    extraProps.onClick = onClick;
  }
  return (
    <li
      className={classNames(navigationMenuListItemClass, classProp)}
      key={link.label}
    >
      <NextLink
        className={navigationMenuLinkClass}
        href={link.url}
        {...extraProps}
      >
        {link.label}
      </NextLink>
    </li>
  );
}

export default NavigationItem;
